import { getMarkJS } from 'owa-mark/lib/utils/constants';
import type { Accuracy } from 'owa-mark/lib/utils/markElements';
import { default as markElements } from 'owa-mark/lib/utils/markElements';
import { getElementColors, setElementOgColorsIfUnset } from 'owa-content-colors';

export const HIT_HIGHLIGHTING_HANDLER_NAME = 'hitHighlightingHandler';
const HIGHLIGHTING_BACKGROUND_COLOR = '#FFF100';
const HIGHLIGHTING_COLOR = 'black';

// used to bypass loading markjs if no
// search terms are ever passed in
let hasEverMarked = false;

export default async function highlightTermsInHtmlElement(
    element: HTMLElement | null,
    highlightTerms: string[],
    separateWordSearch: boolean = false,
    accuracy: Accuracy = 'partially'
): Promise<void> {
    if (element && (highlightTerms?.length || hasEverMarked)) {
        hasEverMarked = true;
        const MarkJS = await getMarkJS();
        const marker = new MarkJS(element);
        if (highlightTerms?.length) {
            if (accuracy === 'prefix') {
                markElements(
                    element,
                    highlightTerms,
                    (_keyword: string, matchedElement: HTMLElement) => {
                        handleHitHighlighting(matchedElement);
                    },
                    false,
                    accuracy
                );
            } else {
                marker.mark(highlightTerms, {
                    separateWordSearch,
                    accuracy,
                });
            }
        } else {
            marker.unmark();
        }
    }
}

function handleHitHighlighting(element: HTMLElement) {
    const originalColors = getElementColors(element);
    element.style.backgroundColor = HIGHLIGHTING_BACKGROUND_COLOR;
    element.style.color = HIGHLIGHTING_COLOR;
    setElementOgColorsIfUnset(element, originalColors);
}
